import { render, staticRenderFns } from "./IssueDetail.vue?vue&type=template&id=070fcc04"
import script from "./IssueDetail.vue?vue&type=script&lang=js"
export * from "./IssueDetail.vue?vue&type=script&lang=js"
import style0 from "./IssueDetail.vue?vue&type=style&index=0&id=070fcc04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports